export default class CarouselMainController {
    onGoto(slide: any) {
        if (slide.carouselItemData?.parameters?.headerTextColorCode) {
            document.documentElement.style.setProperty('--carousel-header-text-color-code', slide.carouselItemData.parameters.headerTextColorCode);
        } else {
            document.documentElement.style.removeProperty('--carousel-header-text-color-code');
        }

        if (slide.carouselItemData?.parameters?.textColorCode) {
            document.documentElement.style.setProperty('--carousel-main-active-text-color-code', slide.carouselItemData.parameters.textColorCode);
        } else {
            document.documentElement.style.removeProperty('--carousel-main-active-text-color-code');
        }
    }
}
